module.exports = {
  "country": "UK",
  "artist": "Lulu",
  "song": "Boom Bang-a-Bang",
  "year": "1969",
  "place": "1",
  "spotify": "0vaRIQTdMIEnXjhWlVS95p"
};